import { render } from "./BomValidationOverviewTooltip.vue?vue&type=template&id=5ad7ca68&scoped=true"
import script from "./BomValidationOverviewTooltip.vue?vue&type=script&lang=js"
export * from "./BomValidationOverviewTooltip.vue?vue&type=script&lang=js"

import "./BomValidationOverviewTooltip.vue?vue&type=style&index=0&id=5ad7ca68&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ad7ca68"]])

export default __exports__